export const renderPrice = price => {
    return Number(price).toLocaleString('pl-PL', {
        currency: 'PLN',
        currencyDisplay: 'name',
        minimumFractionDigits: 2
    });
};
